import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
// import {ProjectsComponent} from './projects/projects.component';
// import {ExperienceComponent} from './experience/experience.component';
// import {LighterComponent} from './lighter/lighter.component';
// import {SamplesComponent} from './samples/samples.component';
import { AboutComponent } from './about/about.component';
import { GenericComponent } from './generic/generic.component';
import { GenericDetailComponent } from './generic-detail/generic-detail.component';
import { BlogComponent } from './blog/blog.component';
import { VideosComponent } from './videos/videos.component';
import { PhotosComponent } from './photos/photos.component';
import {PhotoDetailComponent } from './photo-detail/photo-detail.component';
import { PhotoComponent } from './photo/photo.component';
import { AzureModernizingComponent } from './azure-modernizing/azure-modernizing.component';
import { AzureModernComponent } from './azure-modern/azure-modern.component';
import { DotnetComponent } from './dotnet/dotnet.component';


const routes: Routes = [
  {path: "", pathMatch: "full",redirectTo: "home"},
  {path: "home", component: HomeComponent},
  {path: "azure", component: AzureModernizingComponent},
  {path: "dotnet/:id", component: GenericComponent},
  {path: "azure-modern/:id", component: GenericComponent},
  {path: "projects/:id", component: GenericComponent},
  {path: "experience/:id", component: GenericComponent},
  // {path: "lighter/:id", component: LighterComponent},
  {path: "lighter/:id", component: GenericComponent},
  {path: "samples/:id", component: GenericComponent},
  {path: "blog/:catId", component: BlogComponent},
  {path: "blogPost/:id", component: BlogComponent},
  {path: "about", component: AboutComponent},
  {path: "videos/:id", component: VideosComponent},
  {path: "photos/:id", component: PhotosComponent},
  {path: "photo-detail/:id", component: PhotoDetailComponent},
  {path: "photo/:album/:id", component: PhotoComponent},
  {path: "item-detail/:id", component: GenericDetailComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
